var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { defaultStates } from '@/modules/tasks/taskboard/kanban/constants';
import TaskRow from '@/modules/tasks/taskboard/kanban/task/TaskRow';
import SortTaskComponent from '@/modules/tasks/taskboard/partial/SortTaskComponent';
import taskboardMessages from '@/modules/tasks/taskboard/taskboardMessages';
import TaskContainer from '@/modules/tasks/taskboard/TaskContainer';
import taskMessages from '@/modules/tasks/taskMessages';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import LoadingContainer from '@/shared/components/loading/LoadingContainer';
import { ColumnHeader, ScrollableTable } from '@/shared/components/table';
import { injectStateService } from '@/shared/services/StateService';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import omit from 'lodash-es/omit';
import isEqual from 'lodash-es/isEqual';
import SignalRService from '@/shared/services/SignalRService';
import { useGetPlannedTasks } from '@/shared/hooks/task/useGetPlannedTasks';
import { getLocalStorageItem, LocalStorageKey, setLocalStorageItem, } from '@/shared/services/localStorageService';
import { useQueryClient } from '@tanstack/react-query';
import { TaskQueryKey } from '@/shared/hooks/task/queryKey';
import { ModalType, useModalContext } from '@/shared/providers/ModalProvider';
import { showWhenPermission } from '@/shared/components/security';
import { useGetKPIs } from '@/shared/hooks/task/useGetKPIs';
import { useTaskTimerContext } from '@/shared/providers/TaskTimerProvider';
import { TaskBoardFilters } from './partial/filters/TaskBoardHeader';
import { migrateTaskboardFilters, } from './constants';
import { functionalities, privileges } from '@/shared/services/AuthService';
var TaskboardContainer = function (props) {
    var _a;
    var formatMessage = useIntl().formatMessage;
    var setShowModalInfo = useModalContext().setShowModalInfo;
    var _b = useState(true), openTaskDetailForTaskInRoute = _b[0], setOpenTaskDetailForTaskInRoute = _b[1];
    var stateProps = omit(props, ['dataCache', 'stateService']);
    var initialSearchParams = {
        page: 0,
        pageSize: 50,
        sortKey: 'relation',
        desc: false,
        width: '25vw',
    };
    var queryClient = useQueryClient();
    var handleTaskHasAttachmentsMessage = function (message) {
        var _a;
        if (message.level === 2)
            return; // ignore todo's
        var parentId = null;
        var previousTasks = queryClient.getQueryData([TaskQueryKey.PlannedTasks]);
        var updatedTasksQueryData = __assign({}, previousTasks);
        var mainTasks = (_a = updatedTasksQueryData === null || updatedTasksQueryData === void 0 ? void 0 : updatedTasksQueryData.pages) === null || _a === void 0 ? void 0 : _a.flat(1);
        var isMainTask = message.level === 0;
        var mainTask = mainTasks.find(function (x) { var _a; return x.id === ((_a = message.parentId) !== null && _a !== void 0 ? _a : message.id); });
        if (!mainTask)
            return;
        if (isMainTask) {
            mainTask.hasAttachments = message.hasAttachments;
        }
        else {
            var children = mainTask.children;
            var subTask = children.find(function (x) { return x.id === message.id; });
            if (subTask) {
                parentId = mainTask.id;
                subTask.hasAttachments = message.hasAttachments;
                mainTask.hasAttachments = message.parentHasAttachments;
                mainTask.children = __spreadArray([], children, true); // useEffect in KanbanBoard.tsx is not called without this line, and we need it to trigger the reshuffling of columns
            }
        }
        if (parentId) {
            queryClient.invalidateQueries([TaskQueryKey.TaskAttachments, parentId]);
        }
        queryClient.invalidateQueries([TaskQueryKey.TaskAttachments, message.id]);
        queryClient.setQueryData([TaskQueryKey.PlannedTasks], updatedTasksQueryData);
    };
    // if the route contains a task ID, from either the running task clock icon or the 'share task' link, we want to open the task detail modal of this task. Except for when the user navigated from task overview to taskboard..
    useEffect(function () {
        var plannedTaskId = stateProps.plannedTaskId, _a = stateProps.createTaskForRelation, createTaskForRelation = _a === void 0 ? null : _a;
        if (plannedTaskId && openTaskDetailForTaskInRoute && stateProps.openPlannedTaskDetailModal) {
            setShowModalInfo({
                modalType: ModalType.TaskDetail,
                task: { id: stateProps.plannedTaskId },
            });
            setOpenTaskDetailForTaskInRoute(false);
        }
        else if (openTaskDetailForTaskInRoute && createTaskForRelation) {
            setShowModalInfo({
                modalType: ModalType.OneTimeTask,
                relationId: createTaskForRelation,
            });
            setOpenTaskDetailForTaskInRoute(false);
        }
        SignalRService.subscribe('taskHasAttachmentsChanged', handleTaskHasAttachmentsMessage);
        return function () {
            SignalRService.unsubscribe('taskHasAttachmentsChanged', handleTaskHasAttachmentsMessage);
        };
    }, [stateProps, setShowModalInfo, openTaskDetailForTaskInRoute, setOpenTaskDetailForTaskInRoute]);
    var getInitialOpenTaskIds = function () {
        if (stateProps.plannedTaskId) {
            return [stateProps.plannedTaskId];
        }
        return getLocalStorageItem(LocalStorageKey.TaskBoardContainer_OpenTaskIdsArray, []);
    };
    var _c = useState(getInitialOpenTaskIds()), openTaskIds = _c[0], setOpenTaskIds = _c[1];
    var _d = useState(true), useParametersFromRoute = _d[0], setUseParametersFromRoute = _d[1];
    var setOpenTasks = function (newValue) {
        setLocalStorageItem(LocalStorageKey.TaskBoardContainer_OpenTaskIdsArray, newValue);
        setOpenTaskIds(newValue);
    };
    var getFiltersFromRouteOrLocalStorage = function () {
        var emptyState = {
            invoiceStreamId: null,
            relation: null,
            taskTemplateId: null,
            plannedTaskId: null,
            kpi: null,
            userId: null,
            onlySubtasksForAssignedUser: null,
            userIsNextAssignedUser: null,
            openPlannedTaskDetailModal: true,
            deadlineFrom: null,
            deadlineUntil: null,
            createTaskForRelation: null,
        };
        if (!isEqual(stateProps, emptyState) && useParametersFromRoute) {
            var filterFromState = {};
            if (stateProps.relation) {
                filterFromState.relationId = stateProps.relation.id;
                filterFromState.relationName = stateProps.relation.name;
                delete stateProps.relation;
            }
            if (stateProps.taskTemplateId) {
                filterFromState.taskTemplates = [stateProps.taskTemplateId];
                delete stateProps.taskTemplateId;
            }
            filterFromState = __assign(__assign({}, filterFromState), stateProps);
            if (stateProps.plannedTaskId) {
                setOpenTasks([stateProps.plannedTaskId]);
            }
            sessionStorage.setItem('TaskboardParams', JSON.stringify(__assign({}, filterFromState)));
            // we only want to use the route parameters the first time this method is called, otherwise resetting the filters does not work
            setUseParametersFromRoute(false);
            return filterFromState;
        }
        var storageString = sessionStorage.getItem('TaskboardParams');
        if (!storageString) {
            return undefined;
        }
        try {
            var filterObject = JSON.parse(storageString);
            return filterObject;
        }
        catch (error) {
            console.log(error);
            return {};
        }
    };
    var _e = useState((_a = getFiltersFromRouteOrLocalStorage()) !== null && _a !== void 0 ? _a : {}), activeFilters = _e[0], setActiveFilters = _e[1];
    var _f = useGetPlannedTasks(activeFilters, {
        page: 0,
        take: initialSearchParams.pageSize,
    }), data = _f.data, isLoading = _f.isLoading, onRefetch = _f.refetch, fetchNextPage = _f.fetchNextPage;
    var kpiData = useGetKPIs(activeFilters).data;
    var refetch = function () {
        if (isLoading) {
            var queryKey = [TaskQueryKey.PlannedTasks];
            queryClient.cancelQueries(queryKey);
            queryClient.invalidateQueries({ queryKey: queryKey });
        }
        return onRefetch();
    };
    var loadItems = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetchNextPage()];
                case 1:
                    result = _b.sent();
                    return [2 /*return*/, (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.pages[result.data.pages.length - 1]];
            }
        });
    }); };
    var setTasks = useTaskTimerContext().setTasks;
    useEffect(function () {
        if (data) {
            setTasks(data);
        }
    }, [data, setTasks]);
    var hasOpenTasks = (openTaskIds === null || openTaskIds === void 0 ? void 0 : openTaskIds.length) >= 1;
    var onSetIsAllCollapsed = function () {
        if (hasOpenTasks) {
            setOpenTasks([]);
        }
        else {
            setOpenTasks(data === null || data === void 0 ? void 0 : data.map(function (m) { return m.id; }));
        }
    };
    var onSetIsCollapsed = function (task) {
        var copy = __spreadArray([], openTaskIds, true);
        var index = copy.findIndex(function (x) { return x === task.id; });
        var subtaskIds = task.children ? task.children.map(function (x) { return x.id; }) : [];
        // openTaskIds can contain a subtask id (if navigated from other screen and we want to open this task when navigation to taskboard)
        var taskIsUncollapsedBySubtask = task.children && subtaskIds.some(function (x) { return openTaskIds.includes(x); });
        if (index >= 0) {
            copy.splice(index, 1);
        }
        else if (!taskIsUncollapsedBySubtask) {
            copy.push(task.id);
        }
        if (taskIsUncollapsedBySubtask) {
            copy = copy.filter(function (x) { return !subtaskIds.some(function (y) { return x === y; }); });
        }
        setOpenTasks(copy);
    };
    var onCreateNewTask = function () {
        setShowModalInfo({
            modalType: ModalType.OneTimeTask,
            relationId: activeFilters.relationId,
        });
    };
    var renderRow = function (task) {
        var subTaskIds = task.children ? task.children.map(function (x) { return x.id; }) : [];
        var isCollapsed = !openTaskIds.includes(task.id) && !openTaskIds.some(function (r) { return subTaskIds.includes(r); });
        return (_jsx(TaskRow, { task: task, isCollapsed: isCollapsed, onSetIsCollapsed: onSetIsCollapsed }, task.id + isCollapsed));
    };
    var setFilter = function (filter) {
        setActiveFilters(function (prev) {
            var newFilter = migrateTaskboardFilters(__assign(__assign({}, prev), filter));
            sessionStorage.setItem('TaskboardParams', JSON.stringify(newFilter));
            return newFilter;
        });
        setTimeout(function () {
            refetch();
        }, 0);
    };
    return (_jsxs(_Fragment, { children: [_jsx(TaskBoardFilters, { activeFilters: activeFilters, setFilter: setFilter }), _jsxs(LoadingContainer, __assign({ isLoading: isLoading && !data }, { children: [_jsx("div", __assign({ className: "container-fluid" }, { children: _jsx("div", __assign({ className: "row btn-row" }, { children: kpiData && (_jsxs("span", __assign({ className: "right" }, { children: [data === null || data === void 0 ? void 0 : data.length, " / ", kpiData === null || kpiData === void 0 ? void 0 : kpiData.total] }))) })) })), _jsx(TaskContainer, { children: _jsxs(ScrollableTable, __assign({ tableClassName: "width100pct dskb-layout", loadItems: loadItems, initialSearchParams: initialSearchParams, items: data !== null && data !== void 0 ? data : [], renderRow: function (item) { return renderRow(item); }, noDataLabel: _jsx(FormattedMessage, __assign({}, taskMessages.NoTasksFound)), fetchOnMount: false, renderTBody: true, noHover: true }, { children: [_jsx(ColumnHeader, { title: "" }, "placeholder"), _jsx(ColumnHeader, { title: _jsx(SortTaskComponent, { title: formatMessage(hasOpenTasks ? taskboardMessages.CollapseAll : taskboardMessages.ExpandAll), hasOpenTasks: hasOpenTasks, toggleOpenTasks: onSetIsAllCollapsed }) }, "isAllCollapsed"), defaultStates.map(function (defaultState) { return (_jsx(ColumnHeader, { title: formatMessage(listItemMsg('taskStatus', defaultState.status)) }, defaultState.name)); })] })) })] }))] }));
};
export default showWhenPermission(functionalities.PlannedTask, privileges.Read)(injectStateService(TaskboardContainer));
